/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CrmManagement_FirmsInvestorContactsGridQueryVariables = Types.Exact<{
  firmId: Types.Scalars['UUID']['input'];
  take?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.InvestorFirmContactFilterInput>;
  order?: Types.InputMaybe<
    ReadonlyArray<Types.InvestorFirmContactSortInput> | Types.InvestorFirmContactSortInput
  >;
}>;

export type CrmManagement_FirmsInvestorContactsGridQuery = {
  readonly __typename?: 'Query';
  readonly investorFirmsGrid?: {
    readonly __typename?: 'InvestorFirmsGridCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmsGrid';
      readonly investorContacts?: {
        readonly __typename?: 'InvestorContactsCollectionSegment';
        readonly totalCount: number;
        readonly items?: ReadonlyArray<{
          readonly __typename?: 'InvestorFirmContact';
          readonly name: string;
          readonly firmId: string;
          readonly investorEmployeeId: string;
          readonly investorEmployeeKey?: string | null;
          readonly email1?: string | null;
          readonly email2?: string | null;
          readonly phone1?: string | null;
          readonly phone2?: string | null;
          readonly fax1?: string | null;
          readonly fax2?: string | null;
          readonly address1?: string | null;
          readonly address2?: string | null;
          readonly titles?: ReadonlyArray<string> | null;
          readonly source?: string | null;
          readonly modifiedOn: string;
          readonly status: Types.RolodexRecordStatus;
        }> | null;
      } | null;
    }> | null;
  } | null;
};

export type CrmManagement_AdminFirmsInvestorContactsGridQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['UUID']['input'];
  firmId: Types.Scalars['UUID']['input'];
  take?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.InvestorFirmContactFilterInput>;
  order?: Types.InputMaybe<
    ReadonlyArray<Types.InvestorFirmContactSortInput> | Types.InvestorFirmContactSortInput
  >;
}>;

export type CrmManagement_AdminFirmsInvestorContactsGridQuery = {
  readonly __typename?: 'Query';
  readonly adminInvestorFirmsGrid?: {
    readonly __typename?: 'AdminInvestorFirmsGridCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmsGrid';
      readonly investorContacts?: {
        readonly __typename?: 'InvestorContactsCollectionSegment';
        readonly totalCount: number;
        readonly items?: ReadonlyArray<{
          readonly __typename?: 'InvestorFirmContact';
          readonly name: string;
          readonly firmId: string;
          readonly investorEmployeeId: string;
          readonly investorEmployeeKey?: string | null;
          readonly email1?: string | null;
          readonly email2?: string | null;
          readonly phone1?: string | null;
          readonly phone2?: string | null;
          readonly fax1?: string | null;
          readonly fax2?: string | null;
          readonly address1?: string | null;
          readonly address2?: string | null;
          readonly titles?: ReadonlyArray<string> | null;
          readonly source?: string | null;
          readonly modifiedOn: string;
          readonly status: Types.RolodexRecordStatus;
        }> | null;
      } | null;
    }> | null;
  } | null;
};

export type FirmInvestorContactsGridItemFragment = {
  readonly __typename?: 'InvestorFirmContact';
  readonly name: string;
  readonly firmId: string;
  readonly investorEmployeeId: string;
  readonly investorEmployeeKey?: string | null;
  readonly email1?: string | null;
  readonly email2?: string | null;
  readonly phone1?: string | null;
  readonly phone2?: string | null;
  readonly fax1?: string | null;
  readonly fax2?: string | null;
  readonly address1?: string | null;
  readonly address2?: string | null;
  readonly titles?: ReadonlyArray<string> | null;
  readonly source?: string | null;
  readonly modifiedOn: string;
  readonly status: Types.RolodexRecordStatus;
};

export type InvestorFirms_AddContactMutationVariables = Types.Exact<{
  input: Types.CreateInvestorFirmEmployeeInput;
}>;

export type InvestorFirms_AddContactMutation = {
  readonly __typename?: 'Mutation';
  readonly createInvestorFirmEmployee?: {
    readonly __typename?: 'CreateInvestorFirmEmployeePayload';
    readonly investorFirmContact?: {
      readonly __typename?: 'InvestorFirmContact';
      readonly name: string;
      readonly firmId: string;
      readonly investorEmployeeId: string;
      readonly investorEmployeeKey?: string | null;
      readonly email1?: string | null;
      readonly email2?: string | null;
      readonly phone1?: string | null;
      readonly phone2?: string | null;
      readonly fax1?: string | null;
      readonly fax2?: string | null;
      readonly address1?: string | null;
      readonly address2?: string | null;
      readonly titles?: ReadonlyArray<string> | null;
      readonly source?: string | null;
      readonly modifiedOn: string;
      readonly status: Types.RolodexRecordStatus;
    } | null;
  } | null;
};

export type InvestorFirms_AdminAddContactMutationVariables = Types.Exact<{
  input: Types.AdminCreateInvestorFirmEmployeeInput;
}>;

export type InvestorFirms_AdminAddContactMutation = {
  readonly __typename?: 'Mutation';
  readonly adminCreateInvestorFirmEmployee?: {
    readonly __typename?: 'AdminCreateInvestorFirmEmployeePayload';
    readonly investorFirmContact?: {
      readonly __typename?: 'InvestorFirmContact';
      readonly name: string;
      readonly firmId: string;
      readonly investorEmployeeId: string;
      readonly investorEmployeeKey?: string | null;
      readonly email1?: string | null;
      readonly email2?: string | null;
      readonly phone1?: string | null;
      readonly phone2?: string | null;
      readonly fax1?: string | null;
      readonly fax2?: string | null;
      readonly address1?: string | null;
      readonly address2?: string | null;
      readonly titles?: ReadonlyArray<string> | null;
      readonly source?: string | null;
      readonly modifiedOn: string;
      readonly status: Types.RolodexRecordStatus;
    } | null;
  } | null;
};

export const CrmManagement_FirmsInvestorContactsGridDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CrmManagement_FirmsInvestorContactsGrid' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'InvestorFirmContactFilterInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'InvestorFirmContactSortInput' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'investorFirmsGrid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'investorContacts' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'skip' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'take' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'where' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'order' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'items' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'FirmInvestorContactsGridItem' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FirmInvestorContactsGridItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmContact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_FirmsInvestorContactsGridQuery__
 *
 * To run a query within a React component, call `useCrmManagement_FirmsInvestorContactsGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_FirmsInvestorContactsGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_FirmsInvestorContactsGridQuery({
 *   variables: {
 *      firmId: // value for 'firmId'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCrmManagement_FirmsInvestorContactsGridQuery(
  baseOptions: Apollo.QueryHookOptions<
    CrmManagement_FirmsInvestorContactsGridQuery,
    CrmManagement_FirmsInvestorContactsGridQueryVariables
  > &
    (
      | { variables: CrmManagement_FirmsInvestorContactsGridQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_FirmsInvestorContactsGridQuery,
    CrmManagement_FirmsInvestorContactsGridQueryVariables
  >(CrmManagement_FirmsInvestorContactsGridDocument, options);
}
export function useCrmManagement_FirmsInvestorContactsGridLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_FirmsInvestorContactsGridQuery,
    CrmManagement_FirmsInvestorContactsGridQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_FirmsInvestorContactsGridQuery,
    CrmManagement_FirmsInvestorContactsGridQueryVariables
  >(CrmManagement_FirmsInvestorContactsGridDocument, options);
}
// @ts-ignore
export function useCrmManagement_FirmsInvestorContactsGridSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_FirmsInvestorContactsGridQuery,
    CrmManagement_FirmsInvestorContactsGridQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_FirmsInvestorContactsGridQuery,
  CrmManagement_FirmsInvestorContactsGridQueryVariables
>;
export function useCrmManagement_FirmsInvestorContactsGridSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_FirmsInvestorContactsGridQuery,
        CrmManagement_FirmsInvestorContactsGridQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_FirmsInvestorContactsGridQuery | undefined,
  CrmManagement_FirmsInvestorContactsGridQueryVariables
>;
export function useCrmManagement_FirmsInvestorContactsGridSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_FirmsInvestorContactsGridQuery,
        CrmManagement_FirmsInvestorContactsGridQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_FirmsInvestorContactsGridQuery,
    CrmManagement_FirmsInvestorContactsGridQueryVariables
  >(CrmManagement_FirmsInvestorContactsGridDocument, options);
}
export type CrmManagement_FirmsInvestorContactsGridQueryHookResult = ReturnType<
  typeof useCrmManagement_FirmsInvestorContactsGridQuery
>;
export type CrmManagement_FirmsInvestorContactsGridLazyQueryHookResult = ReturnType<
  typeof useCrmManagement_FirmsInvestorContactsGridLazyQuery
>;
export type CrmManagement_FirmsInvestorContactsGridSuspenseQueryHookResult = ReturnType<
  typeof useCrmManagement_FirmsInvestorContactsGridSuspenseQuery
>;
export type CrmManagement_FirmsInvestorContactsGridQueryResult = Apollo.QueryResult<
  CrmManagement_FirmsInvestorContactsGridQuery,
  CrmManagement_FirmsInvestorContactsGridQueryVariables
>;
export const CrmManagement_AdminFirmsInvestorContactsGridDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CrmManagement_AdminFirmsInvestorContactsGrid' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'InvestorFirmContactFilterInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'InvestorFirmContactSortInput' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminInvestorFirmsGrid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'investorContacts' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'skip' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'take' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'where' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'order' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'items' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'FirmInvestorContactsGridItem' },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FirmInvestorContactsGridItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmContact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_AdminFirmsInvestorContactsGridQuery__
 *
 * To run a query within a React component, call `useCrmManagement_AdminFirmsInvestorContactsGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_AdminFirmsInvestorContactsGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_AdminFirmsInvestorContactsGridQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      firmId: // value for 'firmId'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCrmManagement_AdminFirmsInvestorContactsGridQuery(
  baseOptions: Apollo.QueryHookOptions<
    CrmManagement_AdminFirmsInvestorContactsGridQuery,
    CrmManagement_AdminFirmsInvestorContactsGridQueryVariables
  > &
    (
      | { variables: CrmManagement_AdminFirmsInvestorContactsGridQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_AdminFirmsInvestorContactsGridQuery,
    CrmManagement_AdminFirmsInvestorContactsGridQueryVariables
  >(CrmManagement_AdminFirmsInvestorContactsGridDocument, options);
}
export function useCrmManagement_AdminFirmsInvestorContactsGridLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_AdminFirmsInvestorContactsGridQuery,
    CrmManagement_AdminFirmsInvestorContactsGridQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_AdminFirmsInvestorContactsGridQuery,
    CrmManagement_AdminFirmsInvestorContactsGridQueryVariables
  >(CrmManagement_AdminFirmsInvestorContactsGridDocument, options);
}
// @ts-ignore
export function useCrmManagement_AdminFirmsInvestorContactsGridSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_AdminFirmsInvestorContactsGridQuery,
    CrmManagement_AdminFirmsInvestorContactsGridQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_AdminFirmsInvestorContactsGridQuery,
  CrmManagement_AdminFirmsInvestorContactsGridQueryVariables
>;
export function useCrmManagement_AdminFirmsInvestorContactsGridSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_AdminFirmsInvestorContactsGridQuery,
        CrmManagement_AdminFirmsInvestorContactsGridQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_AdminFirmsInvestorContactsGridQuery | undefined,
  CrmManagement_AdminFirmsInvestorContactsGridQueryVariables
>;
export function useCrmManagement_AdminFirmsInvestorContactsGridSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_AdminFirmsInvestorContactsGridQuery,
        CrmManagement_AdminFirmsInvestorContactsGridQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_AdminFirmsInvestorContactsGridQuery,
    CrmManagement_AdminFirmsInvestorContactsGridQueryVariables
  >(CrmManagement_AdminFirmsInvestorContactsGridDocument, options);
}
export type CrmManagement_AdminFirmsInvestorContactsGridQueryHookResult = ReturnType<
  typeof useCrmManagement_AdminFirmsInvestorContactsGridQuery
>;
export type CrmManagement_AdminFirmsInvestorContactsGridLazyQueryHookResult = ReturnType<
  typeof useCrmManagement_AdminFirmsInvestorContactsGridLazyQuery
>;
export type CrmManagement_AdminFirmsInvestorContactsGridSuspenseQueryHookResult = ReturnType<
  typeof useCrmManagement_AdminFirmsInvestorContactsGridSuspenseQuery
>;
export type CrmManagement_AdminFirmsInvestorContactsGridQueryResult = Apollo.QueryResult<
  CrmManagement_AdminFirmsInvestorContactsGridQuery,
  CrmManagement_AdminFirmsInvestorContactsGridQueryVariables
>;
export const InvestorFirms_AddContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InvestorFirms_AddContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateInvestorFirmEmployeeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createInvestorFirmEmployee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'investorFirmContact' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'FirmInvestorContactsGridItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FirmInvestorContactsGridItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmContact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type InvestorFirms_AddContactMutationFn = Apollo.MutationFunction<
  InvestorFirms_AddContactMutation,
  InvestorFirms_AddContactMutationVariables
>;

/**
 * __useInvestorFirms_AddContactMutation__
 *
 * To run a mutation, you first call `useInvestorFirms_AddContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvestorFirms_AddContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [investorFirmsAddContactMutation, { data, loading, error }] = useInvestorFirms_AddContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvestorFirms_AddContactMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InvestorFirms_AddContactMutation,
    InvestorFirms_AddContactMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InvestorFirms_AddContactMutation,
    InvestorFirms_AddContactMutationVariables
  >(InvestorFirms_AddContactDocument, options);
}
export type InvestorFirms_AddContactMutationHookResult = ReturnType<
  typeof useInvestorFirms_AddContactMutation
>;
export type InvestorFirms_AddContactMutationResult =
  Apollo.MutationResult<InvestorFirms_AddContactMutation>;
export type InvestorFirms_AddContactMutationOptions = Apollo.BaseMutationOptions<
  InvestorFirms_AddContactMutation,
  InvestorFirms_AddContactMutationVariables
>;
export const InvestorFirms_AdminAddContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InvestorFirms_AdminAddContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AdminCreateInvestorFirmEmployeeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminCreateInvestorFirmEmployee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'investorFirmContact' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'FirmInvestorContactsGridItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FirmInvestorContactsGridItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmContact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fax2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type InvestorFirms_AdminAddContactMutationFn = Apollo.MutationFunction<
  InvestorFirms_AdminAddContactMutation,
  InvestorFirms_AdminAddContactMutationVariables
>;

/**
 * __useInvestorFirms_AdminAddContactMutation__
 *
 * To run a mutation, you first call `useInvestorFirms_AdminAddContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvestorFirms_AdminAddContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [investorFirmsAdminAddContactMutation, { data, loading, error }] = useInvestorFirms_AdminAddContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvestorFirms_AdminAddContactMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InvestorFirms_AdminAddContactMutation,
    InvestorFirms_AdminAddContactMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InvestorFirms_AdminAddContactMutation,
    InvestorFirms_AdminAddContactMutationVariables
  >(InvestorFirms_AdminAddContactDocument, options);
}
export type InvestorFirms_AdminAddContactMutationHookResult = ReturnType<
  typeof useInvestorFirms_AdminAddContactMutation
>;
export type InvestorFirms_AdminAddContactMutationResult =
  Apollo.MutationResult<InvestorFirms_AdminAddContactMutation>;
export type InvestorFirms_AdminAddContactMutationOptions = Apollo.BaseMutationOptions<
  InvestorFirms_AdminAddContactMutation,
  InvestorFirms_AdminAddContactMutationVariables
>;
